import React, { FC } from 'react';
import { IconButton } from '@mui/material';
import {
  KeyboardArrowDown as ArrowDown,
  KeyboardArrowLeft as ArrowLeft,
  KeyboardArrowUp as ArrowUp,
  KeyboardArrowRight as ArrowRight,
} from '@mui/icons-material';

interface BackDrawerButtonProps {
  direction: 'left' | 'right' | 'up' | 'down';
}

const BackDrawerButton: FC<BackDrawerButtonProps> = ({ direction }) => {
  const directionIcon = (directionValue: string) => {
    switch (directionValue) {
      case 'right':
        return (
          <ArrowRight
            fontSize="medium"
            sx={{ color: 'primary.contrastText' }}
          />
        );
      case 'up':
        return (
          <ArrowUp fontSize="medium" sx={{ color: 'primary.contrastText' }} />
        );
      case 'down':
        return (
          <ArrowDown fontSize="medium" sx={{ color: 'primary.contrastText' }} />
        );
      default:
        return (
          <ArrowLeft fontSize="medium" sx={{ color: 'primary.contrastText' }} />
        );
    }
  };
  return (
    <IconButton
      sx={{
        display: { xs: 'inline-flex', md: 'none' },
        width: '39px',
        height: '39px',
        '&.MuiButtonBase-root': {
          backgroundColor: 'primary.main',
        },
        border: '3px solid',
        borderColor: '#fff',
      }}
    >
      {directionIcon(direction)}
    </IconButton>
  );
};

export default BackDrawerButton;
